import { Box, Paper, PaperProps, Typography } from '@mui/material';
import { ReactNode } from 'react';

type TileProps = {
  children: ReactNode;
  title: string;
} & PaperProps;

const Tile = ({ title, children, ...rest }: TileProps) => {
  return (
    <Paper square {...rest}>
      <Box p={2}>
        <Typography variant="h5" mb={2}>
          {title}
        </Typography>
        {children}
      </Box>
    </Paper>
  );
};

export default Tile;
